import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core'
import { NbDialogRef, NbDialogService } from '@nebular/theme'
import { EmployeeService } from '../../@core/services/employee.service'
import { SharedService } from '../../@core/services/shared.service'

@Component({
    templateUrl: './single-employee-picker.component.html',
    styleUrls: ['./single-employee-picker.component.scss'],
    selector: 'app-single-employee-picker',
})
export class SingleEmployeePickerComponent implements OnInit {
    @Input() employeeList: Array<any> = null
    @Input() excluded: number[]
    @Input() role: string
    @Output() employee: object
    dataSource: Array<any>
    protected dialogRef: NbDialogRef<any>

    constructor(
        public sharedService: SharedService,
        public employeeService: EmployeeService,
        dialogRef: NbDialogRef<any>
    ) {
        this.dialogRef = dialogRef
    }

    ngOnInit() {
        this.excluded = this.excluded || []
        this.getData()
    }

    getData() {
        if (Array.isArray(this.employeeList)) {
            this.dataSource = this.employeeList || []
            return
        }
        const params = { isWorking: true }
        if (!!this.role) {
            params['role'] = this.role
        }
        this.employeeService.getEmployeeList(params).subscribe((response) => {
            this.dataSource = (response.data || []).filter((e) => {
                return !(this.excluded || []).includes(e.id)
            })
        })
    }

    onItemClick(event) {
        this.dialogRef.close(event)
    }
}
